export default class reportCounter {
    constructor() {
        return {
            scope: {
                countTo: "@",
                duration: "@",
                type: "@",
                counterLabel: "@"
            },
            template: require('../../../../views/directives/report-counter.html'),
            controller: ['$scope', '$element', '$attrs', '$compile', '$filter', (scope, element, attr, $compile, $filter) => {
                scope.label = scope.counterLabel || $filter('translate')('SUBSCRIBER:IMPORT:REPORT:' + scope.type.toUpperCase() );
                scope.counter = 0;
                scope.Math = window.Math;
            }]
        };
    }
}